export const capitalize = <TString extends string>(str: TString) =>
  (str[0].toUpperCase() + str.slice(1)) as Capitalize<TString>;
